import { useState, useMemo, useDeferredValue } from 'react';
import { BasePage, DealGrid, SearchInput } from 'components';

export function SearchPage() {
    const [searchQuery, setSearchQuery] = useState('');
    const [sortBy, setSortBy] = useState('closestTime');
    const [filtersState, setFiltersState] = useState({});

    const deferredSearchQuery = useDeferredValue(searchQuery);

    const filters = useMemo(() => filtersState, [filtersState]);

    const handleSearch = (query) => {
        setSearchQuery(query);
    };

    const handleSort = (sortValue) => {
        setSortBy(sortValue);
    };

    const handleFilter = (newFilters) => {
        setFiltersState(newFilters);
    };

    return (
        <BasePage>
            <SearchInput 
                onSearch={handleSearch} 
                onSort={handleSort} 
                onFilter={handleFilter}
                currentSort={sortBy} 
                currentFilters={filters}
                value={searchQuery}
            />
            <DealGrid 
                searchQuery={deferredSearchQuery} 
                sortBy={sortBy} 
                filters={filters} 
            />
        </BasePage>
    );
}